import type { ReportsAction } from './actions';
import { ReportsActionTypes } from './reportsActionTypes';

import { type WebData, webDataError, webDataFetching, webDataNotAsked } from '@cobliteam/api-lib';

export interface ReportsState {
  driversReportWebData: WebData<void>;
  vehiclesReportWebData: WebData<void>;
  incidentsReportWebData: WebData<void>;
  routesPointsReportWebData: WebData<void>;
}

export const reportsInitialState: ReportsState = {
  driversReportWebData: webDataNotAsked(),
  vehiclesReportWebData: webDataNotAsked(),
  incidentsReportWebData: webDataNotAsked(),
  routesPointsReportWebData: webDataNotAsked(),
};

export const reportsReducer = (state: ReportsState = reportsInitialState, action: ReportsAction): ReportsState => {
  switch (action.type) {
    case ReportsActionTypes.SEND_DRIVERS_REPORT_REQUEST:
      return {
        ...state,
        driversReportWebData: webDataFetching(),
      };

    case ReportsActionTypes.SEND_DRIVERS_REPORT_END:
      return {
        ...state,
        driversReportWebData: webDataNotAsked(),
      };

    case ReportsActionTypes.SEND_DRIVERS_REPORT_FAILURE:
      return {
        ...state,
        driversReportWebData: webDataError(),
      };

    case ReportsActionTypes.SEND_VEHICLES_REPORT_REQUEST:
      return {
        ...state,
        vehiclesReportWebData: webDataFetching(),
      };

    case ReportsActionTypes.SEND_VEHICLES_REPORT_END:
      return {
        ...state,
        vehiclesReportWebData: webDataNotAsked(),
      };

    case ReportsActionTypes.SEND_VEHICLES_REPORT_FAILURE:
      return {
        ...state,
        vehiclesReportWebData: webDataError(),
      };

    case ReportsActionTypes.DOWNLOAD_INCIDENTS_REPORT_REQUEST:
      return {
        ...state,
        incidentsReportWebData: webDataFetching(),
      };

    case ReportsActionTypes.DOWNLOAD_INCIDENTS_REPORT_END:
      return {
        ...state,
        incidentsReportWebData: webDataNotAsked(),
      };

    case ReportsActionTypes.DOWNLOAD_ROUTES_POINTS_REPORT_REQUEST:
      return {
        ...state,
        routesPointsReportWebData: webDataFetching(),
      };

    case ReportsActionTypes.DOWNLOAD_ROUTES_POINTS_REPORT_END:
      return {
        ...state,
        routesPointsReportWebData: webDataNotAsked(),
      };

    default:
      return state;
  }
};
